import { RequireAgent } from "@procurement-agents/auth";
import type { ScopeApi } from "@procurement-agents/scope-api";
import { Route, Routes } from "react-router-dom";
import { ScopeApiProvider } from "./api";
import { NewRequest } from "./views/NewRequest";
import { RunsList } from "./views/RunsList";
import { QaRetrospective } from "./views/QaRetrospective";
import { RunView } from "./views/RunView";
import { HandsFreeProvider } from "./handsFree";
import { RunVoice, VoiceProvider } from "./voice";

/** Mounted by the shell under a base path (e.g. /scope/*). `api` override is for tests. */
export function ScopeAgentApp({ currency, opening, api, domains, voice }: { currency?: string; opening?: string | null; api?: ScopeApi; domains?: Array<{ id: string; name: string }>; voice?: { enabled: boolean; hands_free?: boolean; phrases?: Record<string, string> | null } | null }) {
  return (
    <RequireAgent id="scope">
      <ScopeApiProvider api={api}>
        <VoiceProvider value={{ enabled: !!voice?.enabled }}>
        <HandsFreeProvider settings={{ available: !!voice?.enabled && !!voice?.hands_free, phrases: voice?.phrases ?? null }}>
        <Routes>
          <Route index element={<RunsList />} />
          <Route path="new" element={<NewRequest opening={opening} />} />
          <Route path="qa-retrospective" element={<QaRetrospective />} />
          <Route path="runs/:id" element={<RunVoice><RunView currency={currency} opening={opening} domains={domains} /></RunVoice>} />
          <Route path="sme/:id" element={<RunVoice><RunView currency={currency} opening={opening} domains={domains} /></RunVoice>} />
        </Routes>
        </HandsFreeProvider>
        </VoiceProvider>
      </ScopeApiProvider>
    </RequireAgent>
  );
}
